import { render, staticRenderFns } from "./dhk.vue?vue&type=template&id=f213407c&"
import script from "./dhk.vue?vue&type=script&lang=js&"
export * from "./dhk.vue?vue&type=script&lang=js&"
import style0 from "./dhk.vue?vue&type=style&index=0&id=f213407c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports